// Simple relative time formatter: "just now", "5 minutes ago", "2 hours ago", "21 days ago".
// Returns {relative, exact} where exact is a locale date-time string, or null if iso is falsy.
export function formatRelativeTime(iso) {
  if (!iso) return { relative: "Never", exact: null };
  let d;
  try {
    d = new Date(iso);
    if (isNaN(d.getTime())) return { relative: "Never", exact: null };
  } catch (_e) {
    return { relative: "Never", exact: null };
  }
  const now = Date.now();
  const diffSec = Math.max(0, Math.floor((now - d.getTime()) / 1000));
  let relative;
  if (diffSec < 10) relative = "just now";
  else if (diffSec < 60) relative = `${diffSec} seconds ago`;
  else if (diffSec < 3600) {
    const m = Math.floor(diffSec / 60);
    relative = m === 1 ? "1 minute ago" : `${m} minutes ago`;
  } else if (diffSec < 86400) {
    const h = Math.floor(diffSec / 3600);
    relative = h === 1 ? "1 hour ago" : `${h} hours ago`;
  } else if (diffSec < 30 * 86400) {
    const dd = Math.floor(diffSec / 86400);
    relative = dd === 1 ? "1 day ago" : `${dd} days ago`;
  } else if (diffSec < 365 * 86400) {
    const mo = Math.floor(diffSec / (30 * 86400));
    relative = mo === 1 ? "1 month ago" : `${mo} months ago`;
  } else {
    const y = Math.floor(diffSec / (365 * 86400));
    relative = y === 1 ? "1 year ago" : `${y} years ago`;
  }
  return { relative, exact: d.toLocaleString() };
}
